import { History, HistoryResponse } from "@authentic/loyalty-pwa/interfaces/history.service.interface";
import { useContext, useEffect } from "preact/hooks";
import { HistoryServiceContext } from "@authentic/loyalty-pwa/providers/history.service.context";
import { link, route } from "@authentic/loyalty-pwa/util/route.util";
import { h, FunctionalComponent, Fragment } from "preact";
import { useState } from "react";
import { DelYeahContainer } from "../../../../containers/DelYeahContainer";
import { BackIcon } from "../../../../icons/Back";
import { NextIcon } from "../../../../icons/Next";
import { PreviousIcon } from "../../../../icons/Previous";
import { ActivityItem } from "./activity-item";
import { ActivityItemI, ActivityItemType } from "./activity-item.types";
import { ActivityContentStyled, ActivityEmptyContentStyled, ContentCurrentPage, CurrentPageInput, FormTitleStyled, LayoutStyled, Next, PageDescriptionStyled, PaginatorItem, PaginatorItemsContent, PaginatorStyled, Prev, SubHeadingActivity } from "./view-history.style";

let activities: ActivityItemI[] = [];
let paginationItems: number[] = [];
let totalPagesNumber: number = 0;
export const DelYeahViewHistory: FunctionalComponent = () => {
  const pageTitle: string = 'View History';
  const pageDescription: string = 'Your Del Yeah! transactions from the past 6 months.';
  const emptyHistoryDescription: string = 'Looks like you don’t have any Del Yeah! transactions from the past 6 months.';
  const htmlTitle: string = 'Del Yeah! Rewards History';
  const htmlMetaDescription: string = 'Your Del Yeah! Rewards Dashboard of available rewards and offers.';
  const IDItemMenuSelected: string = '6';
  const historyService = useContext(HistoryServiceContext);
  const [currentTotalPagesNumber, setCurrentTotalPagesNumber] = useState(totalPagesNumber);
  const [totalPages, setTotalPages] = useState(paginationItems);
  const [currentActivitiyPage, setCurrentActivityPage] = useState(1);
  const [activityItems, setActivityItems] = useState<ActivityItemI[]>([]);
  const [firstLoad, setFirstLoad] = useState(true);
  const [loadingActivities, setLoadingActivities] = useState(true);

  useEffect(() => {
    getActivities(currentActivitiyPage);
  }, [firstLoad]);

  const getActivities = (activityPage: number) => {
    setLoadingActivities(true);
    window.scrollTo({ behavior: 'smooth', top: 0 });
    activities = [];
    paginationItems = [];
    /*
    'sl_offer' 'sl_purchase' 'sl_referral' 'sl_reward' 'sl_adjust_earn' 'sl_adjust_redeem' 'sl_order_delivered' 'referral_count'
    */
    historyService?.getHistory({
      period: 'last6m',
      per_page: 10,
      page: activityPage,
      activity_types: 'sl_offer,sl_purchase,sl_reward,sl_submitter,sl_referral,sl_adjust_redeem,sl_adjust_earn,sl_order_delivered,referral_count',
      with_metric_change: true
    })
      .then()
      .then((res: HistoryResponse) => {
        if (res.success) {
          res.histories?.map((activity: History, index: number, activitiesArray) => {
            let formatDateByMonthYear = '';
            if (index === 0) {
              formatDateByMonthYear = formatDateByMonth(new Date(activity.activity_ts));
            } else {
              const formatDateByMonthYearPreviousActivity = formatDateByMonth(new Date(activitiesArray[index - 1].activity_ts));
              formatDateByMonthYear = formatDateByMonth(new Date(activity.activity_ts));
              if (formatDateByMonthYearPreviousActivity === formatDateByMonthYear) {
                formatDateByMonthYear = '';
              }
            }
            activities.push({
              label: (activity.type_name === ActivityItemType.Offer || activity.type_name === ActivityItemType.Reward) ? 'Offer redeemed' : (activity.type_name === ActivityItemType.AdjustEarn) ? "You referred a friend": (activity.label || activity.sl_label),
              itemTypeName: (activity.type_name === ActivityItemType.Offer || activity.type_name === ActivityItemType.Reward) ? 'Redeemed' : (activity.type_name === ActivityItemType.AdjustEarn) ? "Referral" : activity.type_label,
              itemTypeCode: activity.type_name,
              location: activity.sl_location,
              activityDate: formatDate(new Date(activity.activity_ts)),
              activityMonthYearGroup: formatDateByMonthYear,
              metricAmount: activity.metric_amount,
              client: activity.sl_client,
              submitter: activity.sl_submitter,
              totalDollar: activity.total_dollar,
              orderId: activity.sl_transaction_id
            })
          });

          setActivityItems(activities);
          totalPagesNumber = res.total_pages || 0;
          if (activityPage === 1 && res.histories && res.histories.length > 0) {
            setCurrentTotalPagesNumber(totalPagesNumber);
            for (let i = 0; i < totalPagesNumber; i++) {
              paginationItems.push(i + 1);
            }
            setTotalPages(paginationItems);
          }
        }
        setLoadingActivities(false);
      });
  }

  const formatDate = (expirationDate: Date) => {
    let options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    return expirationDate.toLocaleDateString('en-US', options);
  };

  const formatDateByMonth = (expirationDate: Date) => {
    let options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long' };
    return expirationDate.toLocaleDateString('en-US', options);
  };

  const changePage = (page: number, event: any) => {
    setCurrentActivityPage(page);
    getActivities(page);
  };

  const nextPage = (page: number, event: any) => {
    if (page > 1 && page <= totalPagesNumber) {
      getActivities(page);
      setCurrentActivityPage(page);
    }
  }

  const prevPage = (page: number, event: any) => {
    if (page > 0 && page < totalPagesNumber) {
      getActivities(page);
      setCurrentActivityPage(page);
    }
  }

  const onPaginatorInput = (event: any) => {
    const value = parseInt(event.target.value);
    if (value > 0 && value <= totalPagesNumber) {
      getActivities(value);
      setCurrentActivityPage(value);
    }
  };

  const back = () => {
    route('/your-history');
  }

  return (
    <DelYeahContainer htmlTitle={htmlTitle} htmlMetaDescription={htmlMetaDescription} IDItemMenuSelected={IDItemMenuSelected}>
      <LayoutStyled>
        <FormTitleStyled onClick={back}>
          <BackIcon></BackIcon>
          <span>{pageTitle}</span>
        </FormTitleStyled>

        {(activityItems.length > 0 &&
          <ActivityContentStyled>
            <PageDescriptionStyled>{pageDescription}</PageDescriptionStyled>

            {activityItems?.map((item: ActivityItemI) => (
              <Fragment>
                {item.activityMonthYearGroup && (
                  <SubHeadingActivity>{item.activityMonthYearGroup}</SubHeadingActivity>
                )}
                <ActivityItem activityItem={item}></ActivityItem>
              </Fragment>
            ))}

            {currentTotalPagesNumber > 1 && (
              <PaginatorStyled>
                <Prev onClick={prevPage.bind(this, currentActivitiyPage - 1)}
                  className={(currentActivitiyPage === 1) ? 'disabled' : 'enabled'}>
                  <PreviousIcon></PreviousIcon>
                </Prev>
                {/*<PaginatorItemsContent>
                  {totalPages.map((value) => (
                    <PaginatorItem className={(currentActivitiyPage === value) ? 'active' : ''} onClick={changePage.bind(this, value)}> {value} </PaginatorItem>
                  ))}
                </PaginatorItemsContent> */}
                <ContentCurrentPage>
                  Page
                  <CurrentPageInput
                    value={currentActivitiyPage}
                    onInput={onPaginatorInput}>
                  </CurrentPageInput>
                  of {currentTotalPagesNumber}
                </ContentCurrentPage>
                <Next className={(currentActivitiyPage === totalPagesNumber) ? 'disabled' : 'enabled'}
                  onClick={nextPage.bind(this, currentActivitiyPage + 1)}>
                  <NextIcon></NextIcon>
                </Next>
              </PaginatorStyled>
            )}
          </ActivityContentStyled>
        )}

        {(!loadingActivities && activityItems.length === 0 &&
          <ActivityEmptyContentStyled>
            <PageDescriptionStyled>{emptyHistoryDescription}</PageDescriptionStyled>
          </ActivityEmptyContentStyled>
        )}
      </LayoutStyled>
    </DelYeahContainer>
  )
}
